import { render, staticRenderFns } from "./TextoTerminosCondiciones.vue?vue&type=template&id=770c24f3"
import script from "./TextoTerminosCondiciones.vue?vue&type=script&lang=js"
export * from "./TextoTerminosCondiciones.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports